// extracted by mini-css-extract-plugin
module.exports = {"fill":"PageWave_fill__zj70q","wave":"PageWave_wave__QblMq"};